export const WorkData=[
    {
        company:"KPRS & Consultants Pvt. Ltd.",
        designation:"Web Developer",
        dateJoining:"Jan-2020",
        dateEnd:"March-2020",
        companyLogo:require('../../assets/kprs-logo.png').default,
        work: "Designed an E-Commerce platform for buyer, seller & logistics.Frontend Using HTML, CSS, JS, jQuery, Bootstrap.Backend using CodeIgniter a MVC framework in PHP"
    },
    {
        company:"Freelancing",
        designation:"Web Developer",
        dateJoining:"2018",
        dateEnd:"2020",
        companyLogo:require('../../assets/aa.svg').default,
        work: "Developed full stack projects for client in Core PHP. Worked in projects like E-Commerce, Political Leader Portfolio, Company Portfolio, School Websites, News Portals. Worked in CMS like Wordpress, Opencart."
    }
]